import { Col, Container, Row, Spinner } from "react-bootstrap";

import Modal from "../modal";

import token from "../../assets/token.png";

import "./detailsModalStyles.css";

const DetailsModal = ({
  title,
  address,
  details,
  apy,
  liquidity,
  isLoading,
  buttonLabel,
  onPressButton,
  displayModal,
  setDisplayModal,
}) => {
  const getBodyContent = () => (
    <Container className="details-modal-container">
      <Row className="details-modal-row">
        <Col xs={12} className="details-modal-title">
          <span>My Staking Details</span>
        </Col>
      </Row>
      <Row className="details-modal-row">
        <Col xs={7}>
          <span>Locked tokens</span>
        </Col>
        <Col>
          <span>{details.tvl}</span>
        </Col>
      </Row>
      <Row className="details-modal-row">
        <Col xs={7}>
          <span>Staking weight</span>
        </Col>
        <Col>
          <span>{details.weight}</span>
        </Col>
      </Row>
      <Row className="details-modal-row">
        <Col xs={7}>
          <span>Pending rewards</span>
        </Col>
        <Col>
          <span>{details.pen_rew}</span>
        </Col>
      </Row>
      <Row className="details-modal-row">
        <Col xs={7}>
          <span>Pool APY</span>
        </Col>
        <Col>
          <span>{`${apy}%`}</span>
        </Col>
      </Row>
      <Row className="details-modal-row">
        <Col xs={7}>
          <span>My liquidity</span>
        </Col>
        <Col>
          <span>{liquidity}</span>
        </Col>
      </Row>
      {details.totalClaimableTokens && (
        <Row className="details-modal-row">
          <Col xs={7}>
            <span>Total claimable tokens</span>
          </Col>
          <Col>
            <span>{details.totalClaimableTokens}</span>
          </Col>
        </Row>
      )}
      {details.totalTokensRewardedUpToDate && (
        <Row className="details-modal-row">
          <Col xs={7}>
            <span>Total rewards up to date</span>
          </Col>
          <Col>
            <span>{details.totalTokensRewardedUpToDate}</span>
          </Col>
        </Row>
      )}
      {details.timesToNextClaim && details.timesToNextClaim.length > 0 && (
        <Row className="details-modal-row">
          <Col xs={7}>
            <span>Time to next claim</span>
          </Col>
          <Col>
            <span>{details.timesToNextClaim[0]}</span>
          </Col>
        </Row>
      )}
      {isLoading ? (
        <Spinner animation="border" size="sm" />
      ) : (
        <Row className="mt-3">
          <button
            className="details-modal-button green mx-auto w-100"
            onClick={onPressButton}
          >
            {buttonLabel}
          </button>
        </Row>
      )}
    </Container>
  );

  return (
    <Modal
      size="md"
      title={title}
      address={address}
      imageTitle={token}
      bodyContent={getBodyContent()}
      showFooter={false}
      displayModal={displayModal}
      setDisplayModal={setDisplayModal}
    />
  );
};

export default DetailsModal;
